/**
 * Reminder Context
 *
 * Provides openReminder() to any React component, and exposes
 * window.rialtoOpenReminderModal() for vanilla JS (theme templates).
 */

import { createContext, useContext, useState, useEffect, useCallback } from '@wordpress/element';

const ReminderContext = createContext(null);

export function ReminderProvider({ children }) {
    const [reminderData, setReminderData] = useState(null);

    const openReminder = useCallback(({ screeningId, filmTitle, screeningTime }) => {
        setReminderData({ screeningId, filmTitle, screeningTime });
    }, []);

    const closeReminder = useCallback(() => {
        setReminderData(null);
    }, []);

    // Expose to vanilla JS for theme bell buttons
    useEffect(() => {
        window.rialtoOpenReminderModal = openReminder;
        return () => { delete window.rialtoOpenReminderModal; };
    }, [openReminder]);

    const value = {
        reminderData,
        openReminder,
        closeReminder,
    };

    return (
        <ReminderContext.Provider value={value}>
            {children}
        </ReminderContext.Provider>
    );
}

export function useReminder() {
    const context = useContext(ReminderContext);
    if (!context) {
        throw new Error('useReminder must be used within ReminderProvider');
    }
    return context;
}
